import React from "react";
import {PaginationInterface} from "../../../../interfaces/PaginationInterface";
import {useTranslation} from "react-i18next";

interface Props {
    pagination: PaginationInterface;
    setPagination: Function;
    setLoading: Function;
    showMatchingStatus?: boolean;
}

const LogFilters = ({pagination, setPagination, setLoading, showMatchingStatus = false}: Props) => {
    const {t} = useTranslation();
    const updateFilter = async (key: "status" | "data1", value: string) => {
        await setPagination({...pagination, page: 1, [key]: value});
        await setLoading(true);
    };

    return (
        <div className="d-flex flex-wrap gap-2">
            <select
                className="form-select form-select-sm"
                aria-label={t("log.all_statuses")}
                value={pagination.status || ""}
                onChange={(event) => updateFilter("status", event.target.value)}
            >
                <option value="">{t("log.all_statuses")}</option>
                <option value="success">{t("log.success")}</option>
                <option value="error">{t("log.error")}</option>
                <option value="notice">{t("log.notice")}</option>
            </select>
            {showMatchingStatus && (
                <select
                    className="form-select form-select-sm"
                    aria-label={t("log.all_matching_states")}
                    value={pagination.data1 || ""}
                    onChange={(event) => updateFilter("data1", event.target.value)}
                >
                    <option value="">{t("log.all_matching_states")}</option>
                    <option value="pending">{t("log.pending")}</option>
                    <option value="pending_invoice">{t("log.pending_invoice")}</option>
                    <option value="booked">{t("log.booked")}</option>
                    <option value="matched">{t("log.matched")}</option>
                    <option value="no_exist">{t("log.no_exist")}</option>
                </select>
            )}
        </div>
    );
};

export default React.memo(LogFilters);
